import { http, SuccessResponseV1 } from './http'

export type RecordingMode = 'standard' | 'moderator'

export type FeatureList = {
  MaxConferenceDuration: number
  MaxAttendees: number
  MaxHoldConferenceCounts: number
  Recording: boolean
  AvailableRecordingMode: RecordingMode[]
  WebinarMode: boolean
  MaxAudience: number
  MaxAudienceDuration: number
  ConferenceCall: boolean
}

export type License = {
  CreateDate: number
  SaveDate?: number
  ExpireDate: number
  MaxUsers: number
  keyId: string
  CreateDateZh: string
  SIPService: boolean
  FeatureList?: FeatureList
}

//
// GET: /api/v1/licenses
//
export type GetLicensesSuccessResponseV1 = SuccessResponseV1<License>

export async function getLicenseV1API() {
  const { data } = await http.get<GetLicensesSuccessResponseV1>(`/v1/licenses`)
  return data
}
